import styled from 'styled-components';

export const CardStyle = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 280px;
  height: 180px;
  margin: 5px 10px 5px 0;
  padding: 7px;
  background-color: ${({ theme }) => {
    return theme.colors.green;
  }};
  background-color: ${(props) =>
    props.status
      ? ({ theme }) => {
          return theme.colors.card_complete;
        }
      : ({ theme }) => {
          return theme.colors.card_incomplete;
        }};
  color: ${({ theme }) => {
    return theme.colors.black;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  h3 {
    margin: 0;
    padding: 0;
    text-align: center;
    border-bottom: 1px solid #000;
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
  }
  p {
    margin: 2.5px 0;
    padding: 0;
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 20px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    text-decoration: none;
    text-align: center;
    background-color: ${({ theme }) => {
      return theme.colors.backgroundForm;
    }};
    color: ${({ theme }) => {
      return theme.colors.black;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.black;
      }};
      color: ${({ theme }) => {
        return theme.colors.backgroundForm;
      }};
    }
  }
  div {
    display: flex;
    justify-content: space-between;
  }
  button {
    width: 60px;
    height: 20px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    font-family: inherit;
    text-align: center;
    background-color: ${({ theme }) => {
      return theme.colors.backgroundForm;
    }};
    color: ${({ theme }) => {
      return theme.colors.error;
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.error;
      }};
      color: ${({ theme }) => {
        return theme.colors.backgroundForm;
      }};
    }
  }
`;
